import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/ultimate-adventures/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/components/Pagination/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UltimateAdventureCard"] */ "/app/src/components/UltimateAdventureCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourHero"] */ "/app/src/heros/TourHero/index.tsx");
